"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = usePasswordState;

var _react = require("react");

var mapStatuses = {
  weak: 'error',
  average: 'warning',
  strong: 'success'
};

function usePasswordState(passwordState) {
  return (0, _react.useMemo)(function () {
    return mapStatuses[passwordState];
  }, [passwordState]);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/StrongPasswordInput/hooks/usePasswordState.js
// module id = 5EFQ
// module chunks = 0